<template>
  <div class="text-wrapper">
    <div style="margin-bottom: 10px">
      标题: <el-input v-model="tableInfo.query.title" style="width: 200px" size="small" placeholder="请输入标题"></el-input>
      <el-button size="small" type="primary" style="margin: 0 10px 0 30px" @click="getList">查询</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>
    <el-radio-group v-model="tableInfo.query.type" size="small" @change="getList">
      <el-radio-button v-for="item in tabList" :key="item.id" :label="item.id">{{item.label}}</el-radio-button>
    </el-radio-group>
    <br />
    <el-button size="small" type="primary" style="margin-top: 10px" @click="openDia">新建</el-button>
    <div class="table">
      <about-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="true"
        :tab-index="true"
        :api="getAboutList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <template v-slot:col-title="scope">
          <div v-html="scope.row.title"></div>
        </template>
        <template v-slot:col-status="scope">
          {{scope.row.status === 1 ? '已启用' : '已停用'}}
        </template>
        <template v-slot:bt-status="scope">
          <el-button @click="updateAboutUsType(scope.data.row)" type="text">{{scope.data.row.status === 1 ? '停用' : '启用'}}</el-button>
        </template>
        <template v-slot:bt-del="scope">
          <el-button @click="delAboutUs(scope.data.row)" type="text">删除</el-button>
        </template>
      </about-table>
    </div>
    <about-dialog
      ref="aboutDialog"
      :dialog-visible="dialogVisible"
      @close="handleCloseDialog"
      @submit="onSubmit">
    </about-dialog>
  </div>
</template>
<script>
import AboutTable from '@/components/PublicTable';
import AboutDialog from './components/aboutDialog';
import { getAboutList, updateAboutUs, updateAboutUsType, addAboutUs, delAboutUs } from '@/api/api'
export default {
  components: {
    AboutTable,
    AboutDialog
  },
  data() {
    return {
      getAboutList,
      dialogVisible: false,
      tabList: [
        {
          id: 1,
          label: '公司介绍'
        },
        {
          id: 2,
          label: '广电总局人才中心'
        },
        {
          id: 3,
          label: '人才培养计划'
        }
      ],
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {
          type: 1,
          title: ''
        },
        fieldList: [
          // { label: '分页名称', value: 'name', width: '150px'},
          { label: '标题', value: 'title', type: 'slot' },
          { label: '状态', value: 'status', width: '100px', type: 'slot' },
          { label: '操作人', value: 'insertName', width: '100px' },
        ],
        handle: {
          label: '操作',
          width: '150px',
          btList: [
            { label: '编辑', type: 'text', event: 'edit', show: true },
            { label: '启用', type: 'text', event: 'status', show: true, slot: true },
            { label: '删除', type: 'text', event: 'del', show: true, slot: true },
          ]
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    // 提交表单
    onSubmit(form) {
      if (form.id) {
        updateAboutUs(form).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.handleCloseDialog();
            this.getList();
            this.$message.success('编辑成功');
          } else {
            this.$message.error(message);
          }
        })
      } else {
        addAboutUs({ type: this.tableInfo.query.type, ...form }).then(res => {
          this.$message.success('操作成功');
          this.handleCloseDialog();
          this.getList();
        })
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false;
    },
    reset () {
      this.tableInfo.query.title = ''
      this.getList()
    },
    async updateAboutUsType(row) {
      const res = await updateAboutUsType({ id: row.id, status: row.status === 1 ? 2 : 1 })
      this.$message.success('操作成功')
      this.getList()
    },
    delAboutUs(row) {
      this.$confirm('此操作将永久删除这条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delAboutUs({ id: row.id })
        this.$message.success('操作成功')
        this.getList()
      }).catch(() => {});
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random();
    },
    // table操作
    handleClick(event, row) {
      if (event === 'edit') {
        this.dialogVisible = true;
        this.$refs.aboutDialog.init(row);
      }
    },
    openDia() {
      this.dialogVisible = true;
      this.$refs.aboutDialog.init({
        title: '',
        content: ''
      });
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
  },
}
</script>
<style lang="scss" scoped>
.text-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;

  .table {
    margin-top: 20px;
    .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>